import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, SETTINGS } from 'pathnames.js';

// GLOBALE FUNCTIONS
import { makePath } from 'functions';

// GLOBAL HELPERS
import { getListData } from 'helpers/getListData';

// PARTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { ACTIONS, COLUMNS } from 'columns';

// VARIABLES
const LOOKUP_PARAMS = {
  inventorySource: {
    listPage: '1'
  }
};

// MAIN COMPONENT
const InventoryPacksList = () => (
  <Main>
    <Title title="Inventory Packs" tools={<Title.AddNewUsed />} />
    <Filters>
      <Filters.Button.Active />
      <Filters.Button.NewUsed />
      <Filters.Select.InventorySource name="inventorySourceId" lookupParams={LOOKUP_PARAMS.inventorySource} />
      <Filters.Search name="inventoryPackTitle" placeholder="Search by title" />
      <Filters.Reset />
    </Filters>
    <Table mobilePreviewKeys={['pack_title', 'is_active']} />
  </Main>
);

// EXPORT
export default getListData(InventoryPacksList, {
  key: SETTINGS.path,
  path: makePath(INTERFACE.settings, SETTINGS.inventoryPacks),
  fetchArgs: {
    endpoint: ENDPOINTS.admin.inventoryPacks.list
  },
  columns: [
    {
      key: 'pack_title',
      label: 'Title',
      width: 125
    },
    {
      key: 'inventory_source',
      label: 'Source',
      width: 175
    },
    {
      key: 'pack_amount',
      label: 'Amount',
      component: Table.Dollars,
      width: 85
    },
    {
      ...COLUMNS.newUsed,
      numeric: true,
      className: 'text-center',
      width: 35
    },
    {
      ...COLUMNS.active,
      tooltip: 'Only active inventory packs will be available while adding a sale.'
    },
    COLUMNS.updatedOn,
    COLUMNS.updatedBy
  ],
  actions: [ACTIONS.edit('inventory_pack_id')]
});
